import { isMobileState } from "../Composables/useIsMobile.mjs";
const index = {
  computed: {
    /**
     * @deprecated Is to be removed in v9.0.0 with Vue 3 migration.
     *             Use `composables/useIsMobile` instead.
     */
    isMobile() {
      return isMobileState.value;
    }
  }
};
export {
  index as default
};
//# sourceMappingURL=isMobile.mjs.map
